import { withOrdinalSuffix } from '@/utils';
import { BaseAutoTestStep } from './base';
import { errOrData, isEmpty, mergeEithers } from './utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class IOAutoTestStep extends BaseAutoTestStep {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    parseInputData(data) {
        return data;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    getDataToSave() {
        const errs = this._checkProgramNotEmpty();
        if (this.data.inputs.length === 0) {
            errs.push('There should be at least one input output case.');
        }
        else {
            this.data.inputs.forEach((input, i) => {
                const name = `${withOrdinalSuffix(i + 1)} input output case`;
                if (isEmpty(input.name)) {
                    errs.push(`The name of the ${name} is empty.`);
                }
                if (Number(input.weight) < 0) {
                    errs.push(`The weight of the ${name} should not be negative.`);
                }
            });
        }
        return mergeEithers(this._baseGetDataToSave(), errOrData(errs, { data: this.data, type: this.type }));
    }
}
